const GENERIC_ERROR_MESSAGE = 'Operation Failed!';
export default GENERIC_ERROR_MESSAGE;